import React from "react";
import { Modal } from "../components";
import { PulseLoader } from "../components/pulse_loader";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Spacer } from "./spacer";
import { Text } from "./text";

export function LoadingOverlay() {
  const { fbt } = useI18n();
  return (
    <Modal isOpen transparent>
      <div
        className="loading-overlay"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
        }}
      >
        <Text weight="bold" color="primary" size="lg">
          {fbt("Submitting your request")}
        </Text>
        <Spacer size={24} />
        <PulseLoader />
      </div>
    </Modal>
  );
}
